export default __webpack_public_path__ + "static/media/history.f7113036.png";